import Channel from '@/Enums/Channel.enum';
import ChannelId from '@/Enums/ChannelId.enum';
import { NEW_ITEM_ID } from '@/constants/campaignManagement';
import ForecasterWidgetView from '@/pages/CampaignManagement/CreateCampaign/LineItemForm/ForecasterWidget/components/ForecasterWidgetView';
import { useForecaster } from '@/pages/CampaignManagement/CreateCampaign/LineItemForm/ForecasterWidget/hooks/useForecaster';
import { memo, useMemo } from 'react';
import { useWatch } from 'react-hook-form';

interface IProps {
  lineItemIndex: number;
  isExpanded: boolean;
}

const channel = Channel.Google;
const channelId = ChannelId.Google;

const DV360TicketsForecasterWidget = memo(({ isExpanded }: IProps) => {
  const [watchId, watchGeo, watchAudience, watchProduct] = useWatch({
    name: ['id', 'geo', 'audiences', 'product'],
  });

  const isNewLineItem = useMemo(() => watchId === NEW_ITEM_ID, [watchId]);

  const geo = useMemo(() => watchGeo, [JSON.stringify(watchGeo)]);
  const audience = useMemo(() => ({ [channelId]: watchAudience }), [JSON.stringify(watchAudience)]);

  const { activeTab, setActiveTab, forecast, loading, setDaysInRange } = useForecaster({
    channel,
    channelId,
    geo,
    audience,
    productId: watchProduct?.id,
    isNewLineItem,
    initialForecast: null,
    forceInitialFetch: true,
  });

  return (
    <ForecasterWidgetView
      isExpanded={isExpanded}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      loading={loading}
      forecast={forecast}
      // The Google channel has no reach model — the API always forecasts 0 for it, same as in the Forecaster.
      showReach={false}
      channel={channel}
      setDaysInRange={setDaysInRange}
    />
  );
});

export default DV360TicketsForecasterWidget;
